import {
  ProjectHttpClient,
  ProjectManagementHttpClient,
  ProjectStateManagementHttpClient,
  MasterApiClient,
} from './httpClient';

export const getAllProjects = async () => {
  const response = await ProjectStateManagementHttpClient().get('project/list');
  return response.data.items;
};

export const getProjects = async (
  page,
  pageSize,
  filter,
  sortBy = 'id',
  sortDescending = true
) => {
  const response = await ProjectStateManagementHttpClient().get(
    `project/list/all?CurrentPage=${page}&PageSize=${pageSize}&SortBy=${sortBy}&SortDescending=${sortDescending}&ProjectStateFilter=${filter}`
  );
  return response.data;
};

export const getProjectById = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).get(
    `project/${projectId}`
  );
  return response.data;
};

export const getProjectSettingsById = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).get(
    `Project/${projectId}/projectsettings`
  );
  return response.data;
};

export const getProjectNavigationSettings = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).get(
    `Project/${projectId}/settings/navigation`
  );
  return response.data;
};

export const postProject = async (project) => {
  const response = await ProjectManagementHttpClient().post('projects', {
    ...project,
    industryId: parseInt(project.industryId, 10),
    serviceIds: (project.serviceIds || []).map((sp) => parseInt(sp, 10)),
  });
  return response.data;
};

export const updateProjectDetails = async (project) => {
  const response = await ProjectManagementHttpClient().put(
    `projects/${project.id}`,
    {
      ...project,
      type: parseInt(project.type, 10),
      restriction: parseInt(project.restriction, 10),
      industryId: parseInt(project.industryId, 10),
      serviceIds: (project.serviceIds || []).map((sp) => parseInt(sp, 10)),
    }
  );
  return response.data;
};

export const updateProjectSettings = async (projectId, settings) => {
  const response = await ProjectHttpClient.patch(
    `projects/${projectId}/projectSettings`,
    { ...settings }
  );
  return response.data;
};

export const getUserViewStatusCountsForProject = async (projectId) => {
  const response = await ProjectHttpClient.get(
    `projects/${projectId}/userviewstatus/counts`
  );
  return response.data;
};

export const getProjectOptions = async (territory) => {
  const response = await MasterApiClient.get(
    `projects/projectOptions?territory=${territory}`
  );
  return response.data;
};

export const getUsersForComments = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).get(
    `project/${projectId}/users`
  );
  return response.data;
};

export const getSearchProject = async (
  page,
  pageSize,
  searchString,
  filter,
  sortBy = 'id',
  sortDescending = 'true',
  ClientView
) => {
  const response = await ProjectStateManagementHttpClient().get(
    `project/list/search?CurrentPage=${page}&PageSize=${pageSize}&SortBy=${sortBy}&SortDescending=${sortDescending}&ProjectStateFilter=${filter}&SearchString=${searchString}&ClientView=${!ClientView}`
  );
  return response.data;
};

export const getSearchProjectCount = async (
  page,
  pageSize,
  searchString,
  filter,
  sortBy = 'id',
  sortDescending = 'true',
  ClientView
) => {
  const response = await ProjectStateManagementHttpClient().get(
    `project/list/searchcount?CurrentPage=${page}&PageSize=${pageSize}&SortBy=${sortBy}&SortDescending=${sortDescending}&ProjectStateFilter=${filter}&SearchString=${searchString}&ClientView=${!ClientView}`
  );
  return response.data;
};

export const getFavouriteList = async (
  filter,
  sortBy = 'id',
  sortDescending
) => {
  const response = await ProjectStateManagementHttpClient().get(
    `project/list/favourite?ProjectStateFilter=${filter}&SortBy=${sortBy}&SortDescending=${sortDescending}`
  );
  return response.data;
};

export const addProjectToFavourite = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).post(
    `project/${projectId}/favourite`
  );
  return response.data;
};

export const deleteProjectfromFavourite = async (projectId) => {
  const response = await ProjectStateManagementHttpClient(projectId).delete(
    `project/${projectId}/favourite`
  );
  return response.data;
};

export const getListCount = async (filter) => {
  const response = await ProjectStateManagementHttpClient().get(
    `project/list/allcount?ProjectStateFilter=${filter}`
  );
  return response.data;
};
